import { z } from 'zod';
import { roleSchema } from './enums.js';
export const loginInputSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1).max(200),
});
export const sessionUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    role: roleSchema,
    departmentId: z.string().nullable(),
});
//# sourceMappingURL=auth.js.map